<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center pb-2">
        <SectionTitle>
          進路希望
        </SectionTitle>
        <router-link
          v-if="canEdit"
          :to="`/members/${userId}/profile/path_surveys/edit`"
          class="text-decoration-none">
          <icon-button
            class="ml-2"
            width="24"
            height="24"
            icon-size="18"
            icon="edit" />
        </router-link>
        <div
          v-if="pathSurveys"
          class="ml-2 fs-s">
          更新日 {{ pathSurveys.updatedAt | prettyDate }}
        </div>
      </div>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <p class="fs-s pb-2">
      ※希望エリア、条件、受験方法、希望校名などを入力
    </p>
    <b-collapse
      :visible="isCollapseOpen">
      <PathSurveysDisplay
        v-if="pathSurveys"
        :path-surveys="pathSurveys" />
    </b-collapse>
  </div>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import PathSurveysDisplay from '@/components/view/profile/path_surveys/PathSurveysDisplay.vue'
export default {
  components: {
    IconButton,
    SectionTitle,
    CollapseButton,
    PathSurveysDisplay,
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    pathSurveys: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isCollapseOpen: true,
    }
  },
}
</script>

<style>

</style>